import {
  ObjectCondition,
  ObjectTrigger,
  SceneDimmerPowerState,
  SceneDimmerState,
  SceneShutterState,
  SceneStateComparer,
} from '@/../client-generator/generated-clients/plants';
import EnumToRadioButton from '@/views/components/EnumToRadioButton/EnumToRadioButton.vue';
import { Options } from 'vue-class-component';
import SceneTriggerAndConditionGeneral from '../SceneTriggerAndConditionGeneral';

@Options({
  name: 'TriggerAndConditionShutter',
  components: {
    EnumToRadioButton,
  },
  watch: {
    'triggerOrActionToAdd.stateComparer': function () {
      this.stateComparerChanged();
    },
  },
})
export default class TriggerAndConditionShutter extends SceneTriggerAndConditionGeneral {
  SceneStateComparer = SceneStateComparer;
  SceneShutterState = SceneShutterState;
  declare triggerOrActionToAdd: ObjectTrigger | ObjectCondition;
  static readonly MinimumDimmerPercent = 1;

  get sceneStateComparerDisabledChoices() {
    return [SceneStateComparer.Higher, SceneStateComparer.Lower];
  }

  get isConfirmEnabled() {
    return (
      this.triggerOrActionToAdd.stateComparer != SceneStateComparer.None &&
      this.triggerOrActionToAdd.shutterState != SceneShutterState.None
    );
  }

  stateComparerChanged() {
    this.triggerOrActionToAdd.shutterState = SceneShutterState.None;
  }
}
